import React from 'react';

const LogoContainer = ({ src, size = 24 }) => {
  return (
    <div className="logo-container">
      <img src={src} alt="logo" style={{ width: size, height: size }} />
    </div>
  );
};

export default LogoContainer;
